<vn-product-menu [@flyInOut]="state" (@flyInOut.start)="onAnimationEvent($event)" (@flyInOut.done)="onAnimationEvent($event)" />
